import { render, staticRenderFns } from "./SAutocomplete.vue?vue&type=template&id=3abb41eb&scoped=true&"
import script from "./SAutocomplete.vue?vue&type=script&lang=ts&"
export * from "./SAutocomplete.vue?vue&type=script&lang=ts&"
import style0 from "./SAutocomplete.vue?vue&type=style&index=0&id=3abb41eb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3abb41eb",
  null
  
)

export default component.exports